var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',[_c('v-col',[_c('Html')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }